import UpvoteEyes from '../UpvoteEyes';
import './index.less';
import { getPlainText } from "@/utils";

interface IProp {
  item: any, 
  type: 'faq' | 'notice' | 'feedback', 
  upvoteType?: 'question' | 'answer' | 'comment' | 'notice',
  keyWord?: string
}

const QuestionCard = ({item, type, upvoteType = 'question', keyWord = ''}: IProp) => {
  const goDetail = (id: any) => {
    window.open(`/technicalSupport/${type}Detail/${id}`);
  };
  const handleText = (text: string, matchType: 'title' | 'description' | 'reply') => {
    const matchText = item.searchSnippet?.find((v: any) => v.type === matchType);
    const regex = new RegExp(`${keyWord}`, 'gi')
    return keyWord && item.searchMatchType?.includes(matchType) ? 
    `${matchType === 'reply' ? `<span style="font-weight: 600;">${matchText?.nickName}：</span>` : ''}${matchText?.content?.replace(regex, `<span style="color: #0A59F7;">${keyWord}</span>`)}` :
    matchType === 'description' ? getPlainText(text) : text
  }
  return <div
    className="questions-right-item"
    key={item.id}
    
  >
    <div 
      className="questions-right-item-title" 
      onClick={() => {
        goDetail(item.id);
      }}
      dangerouslySetInnerHTML={{ __html: handleText(item?.overview || item?.title, 'title')}}
    >
    </div>
    
    <div 
      className="questions-right-item-content" 
      onClick={() => {
        goDetail(item.id);
      }}
      dangerouslySetInnerHTML={{ __html: handleText(item?.description || item?.content, 'description')}}
    ></div>

    <div className="questions-right-bottom">
      <div className="questions-right-item-time">{item?.createTime}</div>
      <UpvoteEyes
        data={item}
        type={type}   
        upvoteType={upvoteType}    
      />
    </div>
    {
      keyWord && item.searchMatchType?.includes('reply') && 
      <div 
        className='search-match-comment'
        dangerouslySetInnerHTML={{ __html: handleText('', 'reply')}}
      >
      </div>
    }
  </div>;
};

export default QuestionCard;